import Paragraph, { ParagraphSize } from "../../../components/Paragraph";
import TitleText, { TitleTextSize } from "../../../components/TitleText";
import React from "react";

interface DownloadInformationLayoutProps {
  title: string;
  description: string[];
}

const DownloadInformationLayout: React.FC<DownloadInformationLayoutProps> = ({
  title,
  description,
}) => {
  return (
    <>
      <TitleText size={TitleTextSize.heading4}>{title}</TitleText>
      {description.map((item, index) => (
        <Paragraph key={index} size={ParagraphSize.paragraph2}>
          {item}
        </Paragraph>
      ))}
    </>
  );
};

export default DownloadInformationLayout;
